import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@nomoh-monorepo/data-access-auth';
import { AppConfig } from '../models/app-config.interface';
import { resolvePostLoginRoute } from '../utils/auth-redirect.util';

/**
 * Guard para rotas de acesso público (ex: /login).
 * Se o usuário já estiver autenticado, redireciona para o destino pós-login do app.
 */
export const loggedInGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const appConfig = route.data['appConfig'] as AppConfig | undefined;

  if (authService.$loading()) {
    await new Promise<void>((resolve) => {
      const check = () => {
        if (!authService.$loading()) resolve();
        else setTimeout(check, 50);
      };
      check();
    });
  }

  if (authService.$isAuthenticated()) {
    if (authService.redirecionarSePlanoBloqueado()) {
      return false;
    }
    const userId = authService.$user()?.id;
    router.navigate(resolvePostLoginRoute(appConfig, userId));
    return false;
  }

  return true;
};
